import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerEvaluationsModule } from './customer-evaluations/customer-evaluations.module';
import { CustomerEvaluationsComponent } from './customer-evaluations/customer-evaluations.component';
import { OnlineOrderModule } from './online-order/online-order.module';
import { OnlineOrderComponent } from './online-order/online-order.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { RemoteAccessComponent } from './remote-access/remote-access.component';
import { DigitalMenusComponent } from './digital-menus/digital-menus.component';
import { ReservationsComponent } from './reservations/reservations.component';
import { MyReservationsComponent } from './reservations/my-reservations/my-reservations.component';
import { LinkpagesComponent } from './linkpages/linkpages.component';
import { SelfserviceComponent } from './selfservice/selfservice.component';
import { HomeComponent } from './home/home.component';

import { OrderTrackingComponent } from './order-tracking/order-tracking.component';
import { InstallComponent } from './install/install.component';
import { PrivacyComponent } from './legal/privacy/privacy.component';
import { TermsComponent } from './legal/terms/terms.component';
import { SignupLeadComponent } from './signup/lead/signup-lead.component';
import { SignupComponent } from './signup/signup.component';
import { CustomerAreaComponent } from './customer-area/customer-area.component';

const routes: Routes = [
	{
		path: '', component: HomeComponent
	},
	{
		path: 'avaliacoes', component: CustomerEvaluationsComponent
	},
	/** Exists in it's own module OnlineOrderModule
	{
		path: 'pedidos', component: OnlineOrderComponent
	},*/
	{
		path: 'links/:link_name', component: LinkpagesComponent
	},
	{
		path: 'acesso/:company_name', component: RemoteAccessComponent
	},
	{
		path: 'menu/:company_name', component: DigitalMenusComponent
	},
	{
		path: 'menu/:company_name/:dmenu_id', component: DigitalMenusComponent
	},
	{
		path: 'reservas/minhas-reservas', component: MyReservationsComponent,
	},
	{
		path: 'reservas/:company_name', component: ReservationsComponent,
	},
	{
		path: 'mesa/:company_name/:sscode', component: SelfserviceComponent
	},
	{
		path: 'rastreio/:token', component: OrderTrackingComponent
	},
	{
		path: 'instalar', component: InstallComponent
	},
	{
		path: 'cadastro', component: SignupLeadComponent
	},
	{
		path: 'cadastro/:token', component: SignupComponent
	},
	{
		path: 'cliente', component: CustomerAreaComponent
	},
	{
		path: 'privacidade', component: PrivacyComponent
	},
	{
		path: 'termos', component: TermsComponent
	},
	{
		path: 'erro', component: ServerErrorComponent
	}
];

@NgModule({
  imports: [
  	RouterModule.forRoot(routes, {}),
  	CustomerEvaluationsModule,
  	OnlineOrderModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
